import React, { useEffect } from "react";

export function SmsOptInThankYouPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-[42rem] mx-auto px-5 py-10 pb-16 font-sans text-[#1f2328] bg-white leading-relaxed">
      <h1 className="text-3xl font-bold text-[#1f2328] mb-1">
        Thank you &mdash; your request has been received
      </h1>
      <p className="text-sm text-[#5a6169] mb-8">
        Netstratum Inc &middot; 24 Takolusa Dr, Holmdel, NJ 07733 &middot;{" "}
        <a href="https://netstratum.com/" className="text-[#0b5cab] hover:underline">
          netstratum.com
        </a>
      </p>

      <p className="mb-4 text-base">
        If you checked the SMS consent box, you have opted in to receive customer care, account notification, and two-factor authentication (2FA) SMS from Netstratum Inc.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">What happens next</h2>
      <ul className="list-disc pl-5 mb-4 space-y-1 text-base">
        <li>Messaging frequency may vary based on account activity.</li>
        <li>Message and data rates may apply.</li>
        <li>
          Reply <strong>STOP</strong> to any message to opt out. You will receive one confirmation message and no further messages.
        </li>
        <li>
          Reply <strong>HELP</strong> for support, email{" "}
          <a href="mailto:support@netstratum.com" className="text-[#0b5cab] hover:underline">
            support@netstratum.com
          </a>
          , or call +1 732-320-9170.
        </li>
      </ul>

      <p className="mb-6 text-base">
        Mobile opt-in information and your consent to receive SMS notifications will not be shared with any third party or affiliate for marketing or promotional purposes. See our{" "}
        <a href="https://netstratum.com/privacy-policy" className="text-[#0b5cab] hover:underline">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="https://netstratum.com/sms-terms-and-conditions" className="text-[#0b5cab] hover:underline">
          SMS Terms &amp; Conditions
        </a>
        .
      </p>

      <p>
        <a href="https://netstratum.com/sms-opt-in" className="text-[#0b5cab] hover:underline font-semibold">
          Return to the SMS opt-in page
        </a>
      </p>
    </div>
  );
}

export default SmsOptInThankYouPage;
